import { getErrorPayload } from '@application/common/helpers/api-helper';
import OrderApi from '@infrastructure/order-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { addSuccessNotification } from '../common/notificationSlice';
export const getOrderNumberAsync = createAsyncThunk('Order/GetOrderNumber', async (_, { rejectWithValue }) => {
    try {
        const response = await OrderApi.getOrderNumber();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createOrderAsync = createAsyncThunk('Order/Create', async (orderObject, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.createOrder(orderObject);
        dispatch(addSuccessNotification('Bestelling succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getOrderByIdAsync = createAsyncThunk('Order/GetOrderById', async (orderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderApi.getOrderById(orderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllCreditorsAsync = createAsyncThunk('Creditor/GetAll', async (_, { rejectWithValue }) => {
    try {
        const response = await OrderApi.getAllCreditors();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getContactPersonsByIdAsync = createAsyncThunk('debtor/GetContactPersonsByDebitorId', async (debtorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderApi.getContactPersonsById(debtorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkOrdersListWithClientAsync = createAsyncThunk('Order/GetContactPersonsByDebitorIdAsync', async (workOrderNumber, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderApi.getWorkOrdersListWithClientAsync(workOrderNumber);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllOrderStatusAsync = createAsyncThunk('Order/GetAllOrderStatus', async (_, { rejectWithValue }) => {
    try {
        const response = await OrderApi.getAllOrderStatus();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateOrderAsync = createAsyncThunk('Order/Update', async (order, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.updateOrder(order.id, order);
        dispatch(addSuccessNotification('Bestelling succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllOrderAsync = createAsyncThunk('Order/GetAll', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderApi.getAllOrder(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllProgressNotesByOrderIdAsync = createAsyncThunk('Order/GetAllOrderNotesByOrderId', async (workOrderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderApi.getAllProgressNotesByOrderId(workOrderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createProgressNotesByIdAsync = createAsyncThunk('Order/SaveOrderNotesByOrderId', async (note, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.saveProgressNotesById(note);
        dispatch(addSuccessNotification('Voortgangsnotitie succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteProgressNotesByIdAsync = createAsyncThunk('Order/DeleteOrderNotesById', async (orderNotesDto, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.deleteProgressNotesById(orderNotesDto);
        dispatch(addSuccessNotification('Voortgangsnotitie succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllAttachmentsByOrderIdAsync = createAsyncThunk('Order/GetAllAttachmentsByOrderId', async (orderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderApi.getAllAttachmentsByOrderId(orderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const addAttachmentsByOrderIdAsync = createAsyncThunk('Order/UploadOrderAttachment', async (uploadedFile, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.addAttachmentsByOrderId(uploadedFile);
        dispatch(addSuccessNotification('Bestand succesvol geüpload'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteOrderAttachmentAsync = createAsyncThunk('Order/DeleteOrderAttachmentById', async (attachmentId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.deleteOrderAttachment(attachmentId);
        dispatch(addSuccessNotification('Bijlage succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteOrderByIdAsync = createAsyncThunk(`Order/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.deleteOrderById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generatePriceRequestPdfAsync = createAsyncThunk(`Order/GeneratePriceRequestPdf`, async (command, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.generatePriceRequestPdf(command);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateOrderPdfAsync = createAsyncThunk(`Order/GenerateOrderPdf`, async (command, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.generateOrderPdf(command);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateOrderStatusByIdAsync = createAsyncThunk('Order/UpdateOrderStatusById', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.updateOrderStatusById(request);
        dispatch(addSuccessNotification('Status succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateOrderPdfAsAttachmentAsync = createAsyncThunk(`Order/generateOrderPdfAsAttachment`, async (command, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        return await OrderApi.generateOrderPdfAsAttachment(command);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generatePriceRequestPdfAsAttachmentAsync = createAsyncThunk(`Order/generatePriceRequestPdfAsAttachment`, async (command, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderApi.generatePriceRequestPdfAsAttachment(command);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
